"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubNbOperationsSansConseillerCorporation = void 0;
exports.ESubNbOperationsSansConseillerCorporation = {
    none: "none",
    one_to_five: "one_to_five",
    six_to_ten: "six_to_ten",
    more_than_ten: "more_than_ten",
};
